import request from "@/utils/request";

export function getShows(museumId) {
  let params = {
    museumId: museumId,
  };
  return request({
    url: `/api/Shows/GetShows/${museumId}`,
    method: `get`,
    params,
  });
}

export function getShowId(id, params) {
  return request({
    url: `/api/Shows/GetShow/${id}`,
    method: `get`,
    params,
  });
}

export function postShow(data, params) {
  return request({
    url: `/api/Shows/AddShow/${params.museumId}`,
    method: `post`,
    params,
    data,
  });
}

export function putShow(id, data, params) {
  return request({
    url: `/api/Shows/UpdateShow/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function deleteShow(id, params) {
  return request({
    url: `/api/Shows/DeleteShow/${id}`,
    method: "delete",
    params,
  });
}
